import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { JsonPropsType } from '../../component-loader';
import { Endpoint } from './types';
import { Placeholder } from './pages/placeholder';
import { PAGE_REGISTRY } from './pages/registry';

interface EndpointPageData {
  endpoint: Endpoint;
  endpoints: Endpoint[];
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } },
});

export function EndpointPage(props: JsonPropsType) {
  const { endpoint } = props.jsonObject as EndpointPageData;
  const PageComponent = PAGE_REGISTRY[endpoint.slug] ?? Placeholder;

  return (
    <QueryClientProvider client={queryClient}>
      <div className="playground-endpoint">
        <div className="mb-4">
          <h1 className="h3 mb-1">{endpoint.name}</h1>
          <code className="text-secondary small">
            POST
            {endpoint.path}
          </code>
        </div>
        <PageComponent endpoint={endpoint} />
      </div>
    </QueryClientProvider>
  );
}
